import styled from '@/shared/styled';
import { Card } from 'antd';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactZmage from 'react-zmage';
const ROOT = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  .bgc {
    position: fixed;
    z-index: 110;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
  }
  .titles {
    background-color: #fff;
    font-size: 12px;
    position: fixed;
    z-index: 120;
    width: 240px;
    height: 120px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: black;
  }
  .titles > p {
    margin: 20px 15px;
  }
  .titles > div {
    background-color: rgb(76, 116, 242);
    color: #fff;
    width: 80px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    margin: 0 auto;
    border-radius: 4px;
    cursor: pointer;
  }
`;
class Welcome extends Component {
    constructor() {
        super(...arguments);
        this.root = (<ROOT className="bgcBox">
      <div className="bgc"></div>
      <div className="titles">
        <p>继续!</p>
        <div>我知道了</div>
      </div>
    </ROOT>);
    }
    componentDidMount() {
        const divEl = document.createElement('div');
        document.body.appendChild(divEl);
        ReactDOM.render(this.root, divEl);
    }
    render() {
        const { className, style } = this.props;
        return (
        // var imageClass = external_classnames_default()(Image_default.a.imageLayer, set[imageIndex].className, (_classnames = {}, Image_defineProperty(_classnames, Image_default.a.zooming, zoom), Image_defineProperty(_classnames, Image_default.a.invalidate, invalidate), _classnames)); // 組裝屬性
        <div>
        
        <ReactZmage set={[
            {
                src: 'http://assets-devops.oss-cn-hangzhou.aliyuncs.com/95087415fd5df6bd3f84b0adf654c137.png',
                alt: 'aaa',
                className: 'dddddd',
            },
        ]} defaultPage={1}></ReactZmage>
        <Card>
          <h1 style={{ fontSize: '1.5rem' }}>Welcome!</h1>
          <p>
            这是一个基于 muji + antd 开发的 boilerplate，用于快速启动你的项目
          </p>
          <p>除了正常的 muji 配置项外，你还可以：</p>
          <ul>
            <li>修改 src/menu-data.ts 来设置菜单的选项和图标之类</li>
            <li>修改 src/setting.ts 来</li>
          </ul>
          <p>Happy ❤️ Codding</p>
          <br />
          <a href="http://muji.dasouche-inc.net/">muji 文档地址</a>
        </Card>
      </div>);
    }
}
export default Welcome;
